import { isEmpty } from '@axilon-apps/libs-shared-utils'

import useFlashMessages from '../../hooks/use-flash-messages'
import FlashMessageItem from './components/FlashMessageItem/FlashMessageItem'

interface Props {
  group: string
}

const FlashMessages = ({ group }: Props) => {
  const messages = useFlashMessages(group)

  if (isEmpty(messages.all())) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {messages.all().map((message) => (
        <FlashMessageItem key={message.id} message={message} onClose={messages.clear} />
      ))}
    </div>
  )
}

export default FlashMessages
